import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useTrialConfig } from '@app/common/src/hooks/useTrialConfig/useTrialConfig'

export const useTrialBannerState = (): { displayTrialBanner: boolean } => {
  const router = useRouter()
  const trialConfig = useTrialConfig()

  const displayTrialBanner = useMemo(() => {
    const isCodeManagementOrFoldersPage = [Routes.FOLDERS, Routes.CODES, Routes.ASSETS].some(
      val => router.pathname === val
    )
    return isCodeManagementOrFoldersPage && Boolean(trialConfig?.inTrial)
  }, [trialConfig?.inTrial, router.pathname])

  return {
    displayTrialBanner
  }
}
